import { render, staticRenderFns } from "./simpleRegistration.vue?vue&type=template&id=6b1b58f4&scoped=true&"
import script from "./simpleRegistration.vue?vue&type=script&lang=js&"
export * from "./simpleRegistration.vue?vue&type=script&lang=js&"
import style0 from "./simpleRegistration.vue?vue&type=style&index=0&lang=less&"
import style1 from "./simpleRegistration.vue?vue&type=style&index=1&id=6b1b58f4&lang=less&scoped=true&"
import style2 from "./simpleRegistration.vue?vue&type=style&index=2&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b1b58f4",
  null
  
)

export default component.exports